import { IntegrationTypeEnum, Team } from "@finway-group/shared/lib/models"

export const isTeamSourcePersonio = (team: Team) => team?.source?.system === IntegrationTypeEnum.PERSONIO
